import React, { useContext } from 'react';
import {
  SET_DISPLAY_PROFILE_MODAL,
  SET_PROFILE_LAYOUT_TYPE,
} from 'containers/ProfileManager/redux/profile.types';
import { getAdminProfileId } from 'containers/ProfileManager/redux/profile.selectors';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { getUserIsKids } from 'utils/User';
import { getTranslation } from 'utils/getTranslation';
import { UserContext } from 'providers/user.provider';
import FadeInImage from 'components/FadeInImage';
import './style.scss';
import { getRegion } from '../../../../utils/Region';
import getFirstNode from 'utils/getFirstNode';
import { useNavigate, useLocation } from 'react-router-dom';
import { clearRegisterUser } from 'utils/register';
import useHandleUserProvider from 'context/hooks/useHandleUserProvider';
import { useKidProfile } from 'containers/ProfileManager/hooks/useKidProfile';

export const DesktopProfilesMenu = ({ onClose }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const {changeProfile } = useContext(UserContext)
  const { handleChangeProfile } = useHandleUserProvider()
  const adminUserId = useSelector(getAdminProfileId);
  const translations = useSelector(state => state.translations);
  const { profilesInfo } = useSelector(state => state.profilesManager);
  const { isAdmin, gamification_id: gamification_id_current_usr } = useSelector(
    state => state.user,
  );
  const { handlerChangeProfile } = useKidProfile()
  const isKids = getUserIsKids();

  const handleChangeView = () => {
    clearRegisterUser();
    onClose && onClose();
    dispatch({ type: SET_PROFILE_LAYOUT_TYPE, payload: 'MANAGE_PROFILES' });
    dispatch({ type: SET_DISPLAY_PROFILE_MODAL, payload: true });
  };

  const handleProfileSelect = (userHash, gamification_id) => {
    if (gamification_id_current_usr === gamification_id) {
      onClose && onClose();
      return;
    }
    handlerChangeProfile(userHash, profilesInfo, adminUserId, gamification_id, gamification_id_current_usr );
    if(location?.search?.includes('micuenta') || location.pathname?.includes('vcard')){
      navigate(`/${getRegion()}/${getFirstNode()}`);
    }
    onClose && onClose();
  };

  return (
    <>
      {profilesInfo?.members?.map(profile => (
        <li
          key={`menu-select-profile-key-${profile.partnerUserId}`}
          className={'desktop-profile-opt'}
          onClick={() =>
            handleProfileSelect(profile?.user_hash, profile?.gamification_id)
          }
        >
          <FadeInImage
            imageSrc={profile?.user_image}
            imageAlt="av"
            width={27}
            height={27}
            classNames={['desktop-profile-opt__img']}
          />
          <span className="desktop-profile-opt__name">{profile?.username}</span>
        </li>
      ))}
      {!isKids && (
        <li className="menu-avatar-desktop__opt" onClick={handleChangeView}>
          {getTranslation('manageProfiles_access_title_label', translations)}
        </li>
      )}
    </>
  );
};
